/*
 * @Author: Json Chen
 * @Date: 2022-06-13 09:41:33
 * @LastEditTime: 2022-06-13 09:56:34
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/NoPermission/index.tsx
 */
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { IMAGE_URL } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import styles from './css.module.less';
const NoPermission = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { title, subTitle } = props;

  return (
    <div className={styles.noPermissionContainer}>
      <div className={styles.noPermissionWrap}>
        <div className={styles.noPermissionImage}>
          <img src={`${IMAGE_URL}default/nopermission.png`} />
        </div>
        <div className={styles.noPermissionTexts}>
          <p className={styles.noPermissionTitle}>
            {title || getI18n('general.noPermission.title')}
          </p>
          <p className={styles.noPermissionDesc}>
            {subTitle || getI18n('general.noPermissionDesc')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
